module.exports = __webpack_public_path__ + "static/img/30014 (3).5f17cc1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30014 (3).webp
// module id = TvIk
// module chunks = 14